// -----------------------------------------------------------------------------------------------------
// @ Constantes relacionadas con Proyectos
// -----------------------------------------------------------------------------------------------------

/**
 * @constant
 * @desc Cantidad Máxima permitida de Proyectos con red CAN
 */
export const MAX_NUMBER_PROJECTS: number = 15;

/**
 * @constant
 * @desc Cantidad Máxima permitida de Proyectos con red LIN
 */
export const MAX_NUMBER_PROJECTS_LIN: number = 2;

/**
 * @constant
 * @desc Tipo de proyecto
 */
export const PROJECT_TYPE: string = 'MULTIPLEX_PROJECT';

/**
 * @constant
 * @desc Tipo de Archivo
 */
export const TYPE_FILE: string = 'MULTIPLEX_FILE';

/**
 * @constant
 * @desc Cantidad mínima de bloques permitidos
 */
export const MIN_NUMBER_BLOCKS: number = 10;


/**
 * @constant
 * @desc Cantidad máxima de caracteres permitidos en el campo 'Version'
 */
export const MAX_NUMBER_CHAR_VERSION: number = 8;